import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

/**
 * dialog component to show warning when user navigates away from unsaved changes
 *
 * @class ExitDialogComponent
 * @typedef {ExitDialogComponent}
 */
@Component( {
    selector: 'app-exit-dialog',
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './exit-dialog.component.html',
    styleUrl: './exit-dialog.component.scss',
    standalone: true
} )
export class ExitDialogComponent {
    constructor(
        /** reference on dialog wrapper */
        public dialogRef: MatDialogRef<ExitDialogComponent>
    ) { }

    /** pass choice along with closing dialog */
    handleConfirm( choice: boolean ) {
        this.dialogRef.close( choice );
    }
}
